const defaultOptions = {
  defer: true,
};

export const loadScript = ({
  src, options = defaultOptions, onLoad = () => {}, innerScript,
}) => {
  const script = document.createElement('script');
  if (src) {
    script.src = src;
  }
  script.onload = onLoad;
  if (innerScript) {
    script.text = innerScript;
  }

  Object.keys(options).map((key) => {
    script[key] = options[key];
    return undefined;
  });

  document.head.appendChild(script);
};

export const unloadScript = (link) => {
  const script = document.querySelector(`script[src="${link}"]`);
  if (script) {
    script.remove();
  }
};
